import React, { Component } from 'react'
import { connect } from 'react-redux'
import map from 'lodash/map'

import api from '../../api'
import { setSnackbarMessage } from '../../actions/snackbar'
import DeleteIcon from 'material-ui/svg-icons/action/delete'
import ArrowUpward from 'material-ui/svg-icons/navigation/arrow-upward'
import ArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward'

import { CardTitle } from 'material-ui/Card'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import IconButton from 'material-ui/IconButton'
import CircularProgress from 'material-ui/CircularProgress'
import Dialog from 'material-ui/Dialog'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'

const styles = {
  button: {
    margin: '1em 1em 0 0'
  },
  title: {
    paddingLeft: 0
  },
  newRedirectForm: {
    maxWidth: '500px',
    marginBottom: '20px'
  },
  inlineInput: {
    marginLeft: '10px'
  },
  newRedirectInput: {
    width: 'calc(35% - 10px)',
    marginRight: '10px'
  },
  addNewButton: {
    width: '30%'
  },
  table: {
    maxWidth: '1000px'
  }
}

const getItemIndexFromFields = (item, fields) => fields.reduce((accumulator, currentValue, currentIndex) => currentValue.value === item.value ? currentIndex : accumulator, 0)

class ProfileFieldConfig extends Component<any, any> {
  state = {
    currentSelected: '',
    endpoint: `admin/settings/${this.props.field}`,
    loading: true,
    submitting: false,
    submitError: false,
    submitErrorMessage: '',
    showDelete: false,
    newFieldItem: [{
      name: '',
      value: ''
    }]
  }

  componentDidMount () {
    api.get(this.state.endpoint)
      .then((res) => res.json())
      .then(({ value: fields }) => {
        this.setState({ loading: false, fields })
      })
  }

  createNewRedirect = () => {
    this.setState({
      fields: [
// @ts-ignore
        ...this.state.fields,
        {
          name: this.state.newFieldItem[0].name,
          value: this.state.newFieldItem[0].value
        }
      ],
      newFieldItem: [{
        name: '',
        value: ''
      }]
    })
  }

  handleSave = () => {
    this.setState({ submitting: true })
    api.patch(this.state.endpoint, {
// @ts-ignore
      body: { value: this.state.fields }
    })
      .then(res => {
        this.setState({ submitting: false })
        if (res.ok) {
          this.props.onSnackbarMessage('Save successful')
        } else {
          this.setState({ submitError: true, submitErrorMessage: `Unable to save ${this.props.field} configuration. Ensure that every ${this.props.field} field is populated` })
        }
      })
  }

  handleDeleteClose = () => {
    this.setState({
      showDelete: false
    })
  }

  handleDeleteConfirm = () => {
    this.setState({ submitting: true, showDelete: false })

    // update the list of fields after deletion
// @ts-ignore
    const newFields = (this.state.fields).filter((e) => {
      return e.value !== this.state.currentSelected
    })
    api.patch(this.state.endpoint, {
      body: { value: newFields }
    })
      .then(res => res.json().then((error) => {
        this.setState({ submitting: false })
        if (res.ok) {
          this.setState({ fields: newFields })
          this.props.onSnackbarMessage('Delete successful')
        } else {
          this.setState({ submitError: true, submitErrorMessage: error.message })
        }
      }))
  }

  dismissError = () => {
    this.setState({ submitError: false, submitErrorMessage: '' })
  }

  render () {
// @ts-ignore
    const { loading, fields } = this.state
    if (loading) return null

    const buttonStyle = {
      margin: '1em 1em 0 0'
    }

    const deleteActions = [
      <FlatButton
        label='Cancel'
        primary
        onClick={this.handleDeleteClose}
      />,
      <FlatButton
        label='Delete'
        primary
        keyboardFocused
        onClick={this.handleDeleteConfirm}
      />
    ]

    return (
      <div>
        <CardTitle title={`Profile Field Configuration (${this.props.field})`} style={styles.title} />

        <form
          onSubmit={e => {
            e.preventDefault()
            this.createNewRedirect()
          }}
          style={styles.newRedirectForm}
        >
          <TextField
            hintText='Value'
            value={this.state.newFieldItem[0].value}
            onChange={(e, newValue) => this.setState({
              newFieldItem: [{
                ...this.state.newFieldItem[0],
                value: newValue
              }]
            })}
            style={styles.newRedirectInput}
          />
          <TextField
            style={styles.newRedirectInput}
            hintText='Name'
            value={this.state.newFieldItem[0].name}
            onChange={(e, newValue) => this.setState({
              newFieldItem: [{
                ...this.state.newFieldItem[0],
                name: newValue
              }]
            })}
          />
          <RaisedButton
            label='+ Add New'
            primary
            style={styles.addNewButton}
            type='submit'
            disabled={!this.state.newFieldItem[0].name || !this.state.newFieldItem[0].value}
          />
        </form>
        {fields.length > 0 && (
          <Table
            style={styles.table}
            selectable={false}
          >
            <TableHeader
              displaySelectAll={false}
              adjustForCheckbox={false}
            >
              <TableRow>
                <TableHeaderColumn>
                  Value
                </TableHeaderColumn>
                <TableHeaderColumn>
                  Name
                </TableHeaderColumn>
                <TableHeaderColumn>
                  Re-order
                </TableHeaderColumn>
                <TableHeaderColumn>
                  Delete
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={false}
            >
              {map(fields, (item, index) => {
                return (
                  <TableRow key={item.value}>
                    <TableRowColumn>
                      {item.value}
                    </TableRowColumn>
                    <TableRowColumn>
                      <TextField
                        style={styles.inlineInput}
                        name='name'
                        value={item.name}
                        onChange={(e, newValue) => {
// @ts-ignore
                          const fields = this.state.fields
                          const itemIndex = getItemIndexFromFields(item, fields)
                          fields[itemIndex] = {
                            value: item.value,
                            name: newValue
                          }
                          this.setState({
                            fields: fields
                          })
                        }}
                      />
                    </TableRowColumn>
                    <TableRowColumn>
                      <IconButton
                        disabled={index === 0}
                        onClick={() => {
// @ts-ignore
                          const fields = this.state.fields

                          const itemIndex = getItemIndexFromFields(item, fields)
                          fields.splice(itemIndex, 1)
                          fields.splice(itemIndex - 1, 0, item)

                          this.setState({ fields: fields })
                        }}
                      >
                        <ArrowUpward />
                      </IconButton>
                      <IconButton
                        disabled={index === fields.length - 1}
                        onClick={() => {
// @ts-ignore
                          const fields = this.state.fields

                          const itemIndex = getItemIndexFromFields(item, fields)
                          fields.splice(itemIndex, 1)
                          fields.splice(itemIndex + 1, 0, item)

                          this.setState({ fields: fields })
                        }}
                      >
                        <ArrowDownward />
                      </IconButton>
                    </TableRowColumn>
                    <TableRowColumn>
                      <FlatButton
                        label='Delete'
                        secondary
                        onClick={() => {
                          // show delete confirmation modal
                          this.setState({
                            showDelete: true,
                            currentSelected: item.value
                          })
                        }}
                        icon={<DeleteIcon />}
                        style={buttonStyle}
                      />
                      <Dialog
                        title='Confirm delete'
                        actions={deleteActions}
                        modal={false}
                        open={this.state.showDelete}
                        onRequestClose={this.handleDeleteClose}
                      >
                        Are you sure you want to delete this record?
                      </Dialog>
                    </TableRowColumn>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        )}
        <RaisedButton
          label='Save'
          primary
          onClick={this.handleSave}
          style={styles.button}
          labelPosition='before'
          icon={this.state.submitting ? <CircularProgress size={20} thickness={2} /> : null}
          disabled={this.state.submitting}
        />
        <Dialog
          title='Error'
          modal
          open={this.state.submitError}
          actions={[
            <FlatButton
              label='OK'
              primary
              onClick={this.dismissError}
            />
          ]}
          onRequestClose={this.dismissError}
        >
          {this.state.submitErrorMessage}
        </Dialog>
      </div>
    )
  }
}

export default connect(
  null,
  dispatch => ({
    onSnackbarMessage: (msg) => {
      dispatch(setSnackbarMessage(msg))
    }
  })
// @ts-ignore
)(ProfileFieldConfig)
